import { render, staticRenderFns } from "./ColorIcon.vue?vue&type=template&id=a719b6b8&"
import script from "./ColorIcon.vue?vue&type=script&lang=ts&"
export * from "./ColorIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports